import { render, staticRenderFns } from "./UnsavedConfirmationDialog.vue?vue&type=template&id=a45ff6f4"
import script from "./UnsavedConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UnsavedConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports